<template>
  <div class="page">
    <!-- 遮罩 -->
    <div class="mask"></div>

    <!-- 弹窗 -->
    <div class="popup" :style="{ marginTop: `${popup_top}px` }">
      <!-- 弹窗内容 -->
      <div class="popup-content">
        <!-- 背景 -->
        <div class="content-bg">
          <img src="@/assets/images/YuliApp/storageActivity/introduce_bg.png" />
        </div>

        <!-- 文字内容 -->
        <div class="content-text">
          <div class="pos content-text-name">Rules</div>

          <div class="pos content-text-body">
            <div class="text">
              <p>1.</p>
              <p>
                Growth reward can help Yuli holders to improve their overall
                game experience, which can be used in breeding consumption, Yuli
                upgrading consumption, Chips upgrading consumption, shop
                purchase consumption and etc. For each Yuli, only one holder can
                claim its growth reward.
              </p>
            </div>
            <div class="text">
              <p>2.</p>
              <p>
                Holders can obtain the growth reward once the Yuli reach Lv.30.
              </p>
            </div>
            <div class="text">
              <p>3.</p>
              <p>
                When Holders claim the Growth reward, it will be counted into
                the total Growth reward pool for use. Holders has to enable the
                option of using Growth reward at "Setup". When Holders has
                enable it, the Growth reward will be deducted first, and ARG
                Token in wallet will not be deducted until the Growth reward
                balance is not enough to cover the cost.
              </p>
            </div>
            <div class="text">
              <p>4.</p>
              <p>
                It should be noted that growth rewards only apply to Yulis with
                rarity above common.
              </p>
            </div>
            <div class="content-text-body-three">
              <div class="content-text-body-three-rule">
                <p>5.</p>
                <p>
                  The amount of Yuli's growth rewards varies with different
                  rarity. See the following table for details:
                </p>
              </div>
              <div class="content-text-body-three-form">
                <div
                  class="content-text-body-three-form-item"
                  v-for="(item, index) in prize_list"
                  :key="index"
                >
                  <p>{{ item.type }}</p>
                  <p>{{ item.prize }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 弹窗按钮 -->
      <div class="popup-btn" @click="handleClose">
        <img
          src="@/assets/images/YuliApp/storageActivity/icon_delete_nor@2x.png"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import hookStoreState from "@/utils/useState.js";
import { PRIZE_LIST } from "../../constants/storagePrize";
export default {
  setup(props, ctx) {
    const storeStateObj = hookStoreState({
      init: (state) => state.global.init,
      statusBarHeight: (state) => state.global.statusBarHeight,
    });
    const { statusBarHeight } = storeStateObj;
    const popup_top = ref(
      statusBarHeight.value + window.innerHeight * 0.1 - 20
    );
    const prize_list = ref([]);
    onMounted(() => {
      prize_list.value = PRIZE_LIST;
    });

    /**
     * 处理关闭
     */
    const handleClose = () => {
      ctx.emit("close");
    };

    return {
      popup_top,
      handleClose,
      prize_list,
    };
  },
};
</script>

<style lang="less" scoped>
p {
  margin: 0;
  padding: 0;
}
.page {
  width: 100%;
  height: 100%;
  margin-top: -60px;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 999;

  .mask {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    top: 0;
    left: 0;
  }

  .popup {
    width: 351px;
    // margin-top: 128px; // 84
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      height: 100%;
    }

    &-content {
      width: 100%;

      .content {
        &-bg {
          width: 351px;
          height: 551px;
        }

        &-text {
          color: #626e8f;
          font-size: 15px;
          font-weight: 400;
          font-family: "PingFang SC";
          text-align: left;

          .pos {
            position: absolute;
            left: 0;
            right: 0;
            margin: 0 auto;
          }

          &-name {
            top: 39px;
            font-size: 18px;
            font-weight: 500;
            text-align: center;
            line-height: 22px;
          }

          &-body {
            top: 77px;
            width: 241px;
            height: 76%;
            padding-left: 10px;
            font-size: 15px;
            line-height: 20px;
            overflow-y: scroll;
            .text {
              display: flex;
              justify-content: space-between;
              margin-bottom: 7.7px;
              p:nth-of-type(1) {
                margin-right: 6px;
              }
            }
            &-three {
              &-rule {
                display: flex;
                justify-content: space-between;
                p:nth-of-type(1) {
                  margin-right: 6px;
                }
              }
              &-form {
                margin-top: 4px;
                &-item {
                  margin: 0 auto;
                  width: 220px;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  p {
                    border: 0px solid rgba(98, 110, 143, 1);
                    color: rgba(98, 110, 143, 1);
                    font-size: 12px;
                    font-weight: 400;
                    font-family: "PingFang SC";
                    text-align: center;
                    line-height: 26px;
                  }
                  p:nth-of-type(1) {
                    width: 98px;
                    height: 26px;
                    border-width: 1px 0 0 1px;
                  }
                  p:nth-of-type(2) {
                    width: 122px;
                    height: 26px;
                    border-width: 1px 1px 0 1px;
                  }
                }
                .content-text-body-three-form-item:last-child {
                  p {
                    border-bottom-width: 1px;
                  }
                }
              }
            }
          }
          //隐藏滚动条
          .content-text-body::-webkit-scrollbar {
            display: none;
          }
          .content-text-body {
            scrollbar-width: none;
            -ms-overflow-style: none;
            overflow-y: scroll;
            overflow-x: hidden;
          }
        }
      }
    }

    &-btn {
      // margin-top: 28px;
      position: absolute;
      z-index: 999;
      bottom: -55px;
      width: 40px;
      height: 40px;
    }
  }
}
@media screen and (max-height: 700px) {
  .page {
    .popup {
      margin-top: 25px !important;
      &-btn {
        position: absolute;
        z-index: 999;
        bottom: -15px;
        width: 40px;
        height: 40px;
      }
    }
  }
}
</style>
